import i18n from '@dms/i18n';

import {useVehicleFormContext} from '../hooks/useVehicleFormContext';
import {Field} from './primitives/Field';

export function BodyStyleColorSelect() {
  const {catalogueApi} = useVehicleFormContext();
  return (
    <Field
      type="choice"
      name="exteriorColor"
      options={catalogueApi?.bodyColorOptions ?? []}
      label={i18n.t('entity.vehicle.labels.bodyColor')}
    />
  );
}
